var MARCADOR_SALTO_DE_LINEA_DEFECTO = "*";

var validarMarcadorSaltoDeLinea = function validarMarcadorSaltoDeLinea(p_marcadorSaltoDeLinea) {
  if (!p_marcadorSaltoDeLinea || p_marcadorSaltoDeLinea === null || p_marcadorSaltoDeLinea === "") {
    return MARCADOR_SALTO_DE_LINEA_DEFECTO;
  }

  return p_marcadorSaltoDeLinea;
};

var validarCadena = function validarCadena(p_cadena) {
  if (!p_cadena) {
    return "";
  }

  return p_cadena;
};

var reemplazarEspacios = function reemplazarEspacios(p_cadena) {
  var REGEXP_ESPACIO = / /g,
      TAG_ESPACIO = "&nbsp;";
  return p_cadena.replace(REGEXP_ESPACIO, TAG_ESPACIO);
};

var reemplazarNegrita = function reemplazarNegrita(p_cadena) {
  var REGEXP_ABRIR_NEGRITA = /\$B/g,
      REGEXP_CERRAR_NEGRITA = /\/B/g,
      TAG_ABRIR_NEGRITA = "<span class='bold' style='font-weight: bold;'>",
      TAG_CERRAR_NEGRITA = "</span>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_NEGRITA, TAG_ABRIR_NEGRITA);
  return cadena.replace(REGEXP_CERRAR_NEGRITA, TAG_CERRAR_NEGRITA);
};

var reemplazarCursiva = function reemplazarCursiva(p_cadena) {
  var REGEXP_ABRIR_CURSIVA = /\$I/g,
      REGEXP_CERRAR_CURSIVA = /\/I/g,
      TAG_ABRIR_CURSIVA = "<span class='italic' style='font-style: italic;'>",
      TAG_CERRAR_CURSIVA = "</span>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_CURSIVA, TAG_ABRIR_CURSIVA);
  return cadena.replace(REGEXP_CERRAR_CURSIVA, TAG_CERRAR_CURSIVA);
};

var reemplazarSubrayado = function reemplazarSubrayado(p_cadena) {
  var REGEXP_ABRIR_SUBRAYADO = /\$U/g,
      REGEXP_CERRAR_SUBRAYADO = /\/U/g,
      TAG_ABRIR_SUBRAYADO = "<span class='underline' style='text-decoration: underline;'>",
      TAG_CERRAR_SUBRAYADO = "</span>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_SUBRAYADO, TAG_ABRIR_SUBRAYADO);
  return cadena.replace(REGEXP_CERRAR_SUBRAYADO, TAG_CERRAR_SUBRAYADO);
};

var reemplazarSuperindice = function reemplazarSuperindice(p_cadena) {
  var REGEXP_ABRIR_SUPERINDICE = /\$Sp/g,
      REGEXP_CERRAR_SUPERINDICE = /\/Sp/g,
      TAG_ABRIR_SUPERINDICE = "<sup>",
      TAG_CERRAR_SUPERINDICE = "</sup>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_SUPERINDICE, TAG_ABRIR_SUPERINDICE);
  return cadena.replace(REGEXP_CERRAR_SUPERINDICE, TAG_CERRAR_SUPERINDICE);
};

var reemplazarSubindice = function reemplazarSubindice(p_cadena) {
  var REGEXP_ABRIR_SUBINDICE = /\$Sb/,
      REGEXP_CERRAR_SUBINDICE = /\/Sb/,
      TAG_ABRIR_SUBINDICE = "<sub>",
      TAG_CERRAR_SUBINDICE = "</sub>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_SUBINDICE, TAG_ABRIR_SUBINDICE);
  return cadena.replace(REGEXP_CERRAR_SUBINDICE, TAG_CERRAR_SUBINDICE);
};

var reemplazarColor = function reemplazarColor(p_cadena) {
  var REGEXP_ABRIR_COLOR = /\$F#([0-9a-fA-F]+)#/g,
      REGEXP_CERRAR_COLOR = /\/F/g,
      TAG_ABRIR_COLOR = "<span style='color:#$1;'>",
      TAG_CERRAR_COLOR = "</span>",
      cadena;
  cadena = p_cadena.replace(REGEXP_ABRIR_COLOR, TAG_ABRIR_COLOR);
  return cadena.replace(REGEXP_CERRAR_COLOR, TAG_CERRAR_COLOR);
};

var reemplazarSaltosDeLinea = function reemplazarSaltosDeLinea(p_cadena, p_marcador_salto_de_linea) {
  var marcador_salto_de_linea = validarMarcadorSaltoDeLinea(p_marcador_salto_de_linea),
      REGEXP_SALTO_DE_LINEA = new RegExp("\\" + marcador_salto_de_linea, "g"),
      TAG_SALTO_DE_LINEA = "<br>";
  return p_cadena.replace(REGEXP_SALTO_DE_LINEA, TAG_SALTO_DE_LINEA);
};

var normalizarTexto = function normalizarTexto(p_cadena, p_marcadorSaltoDeLinea) {
  var cadena = validarCadena(p_cadena);
  cadena = reemplazarEspacios(cadena);
  cadena = reemplazarNegrita(cadena);
  cadena = reemplazarCursiva(cadena);
  cadena = reemplazarSubrayado(cadena);
  cadena = reemplazarSuperindice(cadena);
  cadena = reemplazarSubindice(cadena);
  cadena = reemplazarColor(cadena);
  cadena = reemplazarSaltosDeLinea(cadena, p_marcadorSaltoDeLinea);
  return cadena;
};

export default normalizarTexto;